export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    console.log("Text copied to clipboard");
  } catch (err) {
    console.error("Failed to copy text: ", err);
  }
};

export const checkEvenNumberQuotes = (str) => {
  return (String(str).match(/"/g) || []).length % 2 === 0;
};

export const cleanStringToArray = (line) => {
  // Use regex to match comma-separated values and keep quoted text intact
  const regex = /(".*?"|[^,\s]+)(?=\s*,|\s*$)/g;
  const matches = [...line.matchAll(regex)];

  // Clean up each match by removing surrounding quotes and trimming
  return matches.map((match) => match[0].trim().replace(/^["]|["]$/g, ""));
};

export const convertBytesToGB = (bytes) => {
  const BYTES_IN_GB = 1024 ** 3;
  // Use `== null` to check for both null and undefined
  if (bytes == null) {
    return null;
  }

  if (bytes === 0) {
    return "0.000";
  }

  const gb = bytes / BYTES_IN_GB;

  // If the value is very small but not zero, show a minimum value
  if (gb < 0.001) {
    return "0.001";
  }

  return gb.toFixed(3);
};
